/**
 * Safely create number formatter for currencies.
 *
 * {@link Intl.NumberFormat} constructor can fail in some cases, e.g.
 * - for invalid units
 * - for invalid currency codes
 * @param locales
 * @param options
 * @returns
 */
export function tryCreateNumberFormat(locales, options) {
    try {
        // this can throw an error if the currency does not exist
        return new Intl.NumberFormat(locales, options);
    }
    catch (_err) {
        // silently fail to prevent the log spamming
        return new Intl.NumberFormat(locales);
    }
}
//# sourceMappingURL=tryCreateNumberFormat.js.map